<template>
	<div id="app">
		<template v-if="hasHeader">
			<!-- <Header v-show="haslogin"></Header>
			<Header2 v-show="!haslogin"></Header2> -->
			<Header3></Header3>
		</template>
		<section class="section">
			<router-view />
		</section>
	</div>
</template>
<script>
	import Header from '@/components/header.vue';
	import Header2 from '@/components/header2.vue';
	import Header3 from '@/components/header3.vue';
	export default {
		name: '',
		components: {
			Header,
			Header2,
			Header3
		},
		data() {
			return {
				isActive: false,
				haslogin: true,
				hasHeader:true,
			}
		},
		watch: {
		    '$route'(to, from) {
				// 路由变化时的处理逻辑
				if(to.path=='/mapFull' || to.path=='/mapFullImg' ){
					this.hasHeader=false;
				}
				if(to.path=='/index'){
					this.haslogin=true;
				}else{
					this.haslogin=false;
				}
		    }
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>
<style>
	.section{
		height: calc( 100vh - 74px );
	}
	
</style>